import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-lcl-quote-total-cost',
  templateUrl: './lcl-quote-total-cost.component.html',
  styleUrls: ['./lcl-quote-total-cost.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclQuoteTotalCostComponent implements OnInit {
  @Output() public bookQuoteSource: EventEmitter<void> = new EventEmitter<void>();
  @Input() public price: number;
  @Input() public validity: string;
  public formatDateTime: string = 'MM/dd/yyyy';

  constructor() {}

  public ngOnInit(): void {}

  public bookQuote(event: Event): void {
    this.bookQuoteSource.emit();
  }
}
